module.exports = __webpack_public_path__ + "media/promo/courses/images/task-julia-d176f00723e7402d406988921913ae07.png";